import { useEffect } from "react";

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    window.scrollTo(0, 0);
  }, [title, description]);
}
